<div class="popup-container">
    <div class="closepop p-3">
        <button class="btn btn-cancel btn-sm" (click)="dialogRef.close()" title="{{'Close' | translate}}">
            <em class="fa fa-times"></em>
        </button>
    </div>
    <div class=" col-md-12 justify-content-center ">
        <div class="row" [hidden]="!loginBoolean">
            <div class="modal-header">
                <h2 class="text-theme ms-3">Sign in</h2>
                <!-- <button mat-icon-button (click)="dialogRef.close()" class="close-button">
                <mat-icon>close</mat-icon>
            </button> -->
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 " [hidden]="MobileHide">

                <form class="form" [formGroup]="MobileForm">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 pt-2 ps-5 pe-5 ">
                        <label class=""><mat-label for="phoneNumber">
                                <span class="mat-label">{{'Phone_number'|translate}}
                                    <span class="required-icon">*</span></span>
                            </mat-label></label>
                        <div class="phone-form-input">
                            <mat-form-field class="country-code-field">
                                <mat-select formControlName="countryCode" id="countryCode" placeholder="Select">
                                    <mat-option *ngFor="let code of phoneCodes" [value]="code.masterDataID">
                                        {{ code.mdTitle }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="input-wrapper" floatLabel="always">
                                <mat-label class=" phone-number-field  "> </mat-label>
                                <input matInput id="phoneNumber" name="phone-number" placeholder="Enter the Phone Number" autocomplete="off"
       formControlName="phoneNumber" (keypress)="numberOnly($event)" >

                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error *ngIf="isSubmittedMobile && mobilecontrol?.['phoneNumber']?.errors?.required">
                                {{'PhoneNumber_is_required'|translate}}

                            </mat-error>
                            <mat-error
                                *ngIf="isSubmittedMobile && (mobilecontrol?.['phoneNumber']?.errors?.minlength||mobilecontrol?.['phoneNumber']?.errors?.maxlength)">
                                {{'PHONE_NUMBER_Invalid'|translate}}
                            </mat-error>
                        </div>
                    </div>


                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-8">
                            <button mat-button type="submit" class="otp-button btn" (click)="MobileFormSubmit()">
                                Sign in with OTP <em class="fa-solid fa-lg fa-arrow-right"></em>
                            </button>
                        </div>
                    </div>

                </form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 " [hidden]="!MobileHide">
                <form class="form row" [formGroup]="EmailForm">
                    <div class="col-xs-12 col-sm-12 col-md-12 ps-5 pe-5">
                        <mat-form-field class="input-wrapper " floatLabel="always">
                            <label class="pb-2">
                                <mat-label for="Email">
                                    <span class="mat-label">{{'Email'| translate}} <span
                                            class="required-icon">*</span></span>
                                </mat-label>
                            </label>
                            <input matInput type="email" id="Email" placeholder="Enter the Email ID"
                                formControlName="email"
                                [ngClass]="{ 'is-invalid': submittedEmail && controlEmail['email'].errors }"
                                autocomplete="off">
                        </mat-form-field>
                        <div *ngIf="controlEmail['email'].errors && submittedEmail">
                            <mat-error *ngIf="controlEmail['email'].errors['required']"
                                class="text-danger letterspacing">
                                {{'user_email_is_required'|translate}} </mat-error>
                            <mat-error
                                *ngIf="controlEmail['email'].errors['pattern'] || controlEmail['email'].errors['email']"
                                class="text-danger letterspacing">
                                {{'EmailID_INvalid'|translate}} </mat-error>
                        </div>



                    </div>

                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-8">
                            <button mat-flat-button type="submit" class="otp-button btn" (click)="EmailFormSubmit()">
                                Sign in with OTP <em class="fa-solid fa-lg fa-arrow-right"></em>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="d-flex justify-content-center">
                <div class="col-xs-12 col-sm-12 col-md-8 ">
                    <div class="separator ">or</div>
                    @if(!MobileHide){
                    <button mat-button type="submit" class="google-button btn" (click)="signInEmail()">
                        <em class="fa fa-lg fa-envelope"></em> Sign in with Email
                    </button>
                    }
                    <!-- @if(MobileHide){
                    <button mat-button type="submit" class="phone-button btn" (click)="signInPhoneNo()">
                        <em class="fa fa-lg fa-mobile-phone"></em> Sign in with Phone Number
                    </button>
                    } -->
                    <div id="google-button" class="mt-4"></div>
                    <!-- <button mat-button class="whatsapp-button btn" (click)="signInWithWhatsApp()">
                        <em class="fa fa-lg fa-whatsapp"></em> Sign in with WhatsApp
                    </button> -->
                    <!-- <button mat-button class="google-button btn" id="google-button">
                    <em class="fa fa-google"></em> Sign in with Google
                </button> -->
                </div>
            </div>
        </div>
        <div class="row" [hidden]="loginBoolean">

            <div class="text-center mt-5 mb-4">
                <p>{{emaiauthentication??''}}</p>
            </div>

            <form class="form" [formGroup]="OTPForm">
                <div>
                    <div class="classfifty input-group form-group justify-content-center mt-2">
                        <div class="input-group-prepend mb-2 mb-sm-0">
                            <span class="input-group-text colordiv"><i class="fa fa-lock lockIcon colordiv"></i></span>
                        </div>
                        <div class="otp-input-container">
                            <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
                                <input #otpInput type="tel" minlength="1" maxlength="1" (keypress)="numberOnly($event)"
                                    (input)="onInputChange($event,'otp' + index)" [id]="'otp' + index"
                                    (keydown)="onBackspaceKeyDown($event, index)" [formControlName]="'otp' + index"
                                    (keyup)="onOtpInput(index)">
                            </div>
                        </div>
                    </div>
                    <div class=" classfifty input-group form-group justify-content-center my-3">
                        <div *ngIf="b['otp'].errors && submittedotp" class="small">
                            <div *ngIf="b['otp'].errors['required']" class="text-danger letterspacing">
                                {{'OTP_is_required'|translate}} </div>

                        </div>
                    </div>
                    <p class="text-center mb-1 mt-3" *ngIf="showResend==false ">{{'OTP_request' | translate}}</p>

                    <div class="load" *ngIf="showResend==false ">
                        <div class="progress-time mx-4" [style.--progress-value]="timeRemaining_percent">
                            <progress style="visibility:hidden;height:0;width:0;"></progress>
                            <span class="progress-value">{{remainingTime}}</span>
                        </div>
                    </div>

                    <div class="text-center m-2" *ngIf="showResend==true">
                        <p class="mt-3">{{'OTP_Question' | translate}} <a href="javascript: void(0)"
                                (click)="resendOtp()">{{'Resend_OTP' | translate}}</a></p>

                    </div>

                    <div class="form-group text-center my-2 mt-4 submit">
                        <button class="classfifty btn btnreset capitilize letterSpacing m-1" mat-button
                            (click)="goBack()" type="reset"><em class="fa fa-fw fa-arrow-left"></em>
                            {{'Go_Back'|translate}}
                        </button>&nbsp;
                        <button type="submit" class="classfifty btn btnAfr  m-1" mat-button (click)="otpSubmit()"><em
                                class="fa fa-fw fa-key"></em>
                            {{'Validate_OTP'|translate}}
                        </button>

                    </div>

                </div>
            </form>

        </div>
    </div>
</div>